{
    "appearance": {
        "panels": {
            "tools": {
                "dock": "right"
            }
        },
        "theme": "modern_light"
    },
    "customCSS": [
        ".blockbuilder-tools-panel { background-color: var(--base-100); };",
        ".blockbuilder-tools-panel > .nav-tabs-bg { background-color: var(--base-300) }",
        ".blockbuilder-tools-panel > .nav-tabs .nav-item .nav-link { background-color: var(--base-300); }",
        ".blockbuilder-tools-panel > .nav-tabs .nav-item .nav-link.active { background-color: var(--base-100); }",
        ".blockbuilder-tools-panel > .nav-tabs .nav-item .nav-link:hover { background-color: var(--base-100); }",
        ".blockbuilder-tools-panel .caret.caret-left::before { border-right-color: var(--base-300); }",
        ".blockbuilder-tools-panel .caret.caret-left::after { border-right-color: var(--base-100); }",
        ".nav-tabs { background-color: var(--base-100); color: var(--base-700); };",
        ".actions-container { border-radius: 4px; background-color: var(--base-100); border-color: var(--base-300); };",
        ".actions-container div { color: var(--base-700); };",
        ".actions-container a:hover { color: var(--base-600);};",
        ".actions-container .selected a { color: var(--primary-300);};",
        "#editor .loadedContent .u_body { min-height: calc(100vh - 55px) !important }"
    ],
    "features": {
        "ai": true,
        "audit": false,
        "stockImages": {
            "enabled": false
        },
        "userUploads": false
    },
    "projectId": 70008,
    "tabs": {
        "audit": {
            "active": false,
            "enabled": false,
            "position": 4
        },
        "blocks": {
            "active": false,
            "position": 2
        },
        "body": {
            "active": false,
            "position": 3
        },
        "contents": {
            "active": false,
            "position": 1
        },
        "uploads": {
            "enabled": false
        }
    },
    "tools": {
        "button": {
            "position": 3
        },
        "divider": {
            "position": 5
        },
        "form": {
            "enabled": false
        },
        "heading": {
            "position": 1
        },
        "html": {
            "enabled": true
        },
        "image": {
            "position": 4
        },
        "menu": {
            "enabled": false
        },
        "text": {
            "position": 2
        }
    }
}
